import { createSlice, createAsyncThunk, createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import axios from 'axios';
import globalConfig from '../../configs/globalConfigs';
import { mapGraphDetails } from '../../utils/entity-utils';
import { MODEL_SOURCE, SINGLE_KPI_SCENARIO } from '../../constants';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const mainContentAdapter = createEntityAdapter();

const initialState = mainContentAdapter.getInitialState({
  loading: false,
  error: null,
  isMetricsAvailable: false,
});

const mainContentSlice = createSlice({
  name: 'mainContent',
  initialState,
  reducers: {
    updateIsMetricsAvailable(state, action) {
      state.isMetricsAvailable = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllGraphDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllGraphDetails.fulfilled, (state, action) => {
      state.loading = false;
      mainContentAdapter.setAll(state, action.payload);
    });
    builder.addCase(getAllGraphDetails.rejected, (state, action) => {
      state.loading = false;
      mainContentAdapter.setAll(initialState);
      state.error = action.error.message;
    });
  },
});

export const { updateIsMetricsAvailable } = mainContentSlice.actions;
export default mainContentSlice.reducer;

/* ----------------------------------------------------------------
      MIDDLEWARE - API CALLS
---------------------------------------------------------------- */

export const getAllGraphDetails = createAsyncThunk('mainContent/fetchGraphDetails', async (initialPost) => {
  const { source, visualisation } = initialPost;

  let url = source === MODEL_SOURCE ? globalConfig.API_GRAPH_DETAIL_URL : globalConfig.API_GRAPH_DETAIL_URL_OFFICIAL;
  if (visualisation === SINGLE_KPI_SCENARIO) url = globalConfig.API_KPIS_GRAPHS_DETAILS_URL;

  const result = await axios.get(url);

  return mapGraphDetails(result.data);
});

/* ----------------------------------------------------------------
      SELECTORS
---------------------------------------------------------------- */

export const graphDetailsSelector = mainContentAdapter.getSelectors((state) => state.pathwaysDomain.mainContent);

const globalFilterSelector = (state) => state.globalDomain.filters.global;

export const mainContentInformation = createSelector(
  graphDetailsSelector.selectAll,
  globalFilterSelector,
  (elements, { category, subcategory }) => elements.filter((element) => element.category === category && element.subcategory === subcategory) || [],
);
